<div *ngIf="(data.modalIcon || data.svgIcon); else templateNameModalIcon">
    <mat-icon class="dialogIcon" color="warn"  *ngIf="data.modalIcon">{{data.modalIcon}}</mat-icon>
    <mat-icon class="dialogIcon" *ngIf="data.svgIcon" [svgIcon]="data.svgIcon"></mat-icon>
    <span class="modal-header font-size-18 text-bold red-500-fg" [ngClass]="(data.isResponse ? 'green-500-fg ' : 'red-500-fg ') + data.headerClass">{{ data.confirmHeader }}</span>
</div>
<ng-template #templateNameModalIcon>
    <div class="modal-header font-size-18 text-bold artstuff-orange-fg">{{ data.confirmHeader }}</div>
</ng-template>
<div mat-dialog-content class="p-0 font-weight-400 mat-body-1 grey-900-fg" [innerHTML]="data.confirmMessage">{{ data.confirmMessage }}</div>
<div class="w-100-p text-center">
    <span *ngIf="!data.hideAcceptBtn" class="mr-12">
        <button *ngIf="data.acceptBtnText; else templateNameAcceptBtn" mat-raised-button
        class="artstuff-dialog-button mat-subheading-2"
        [ngClass]="(data.modalIcon || data.svgIcon)? data.isResponse? 'green-500-bg fuse-white-fg' : 'red-500-bg fuse-white-fg' : 'artstuff-orange'"
        (click)="dialogRef.close(true)">
            {{ data.acceptBtnText }}
        </button>
        <ng-template #templateNameAcceptBtn>
            <button mat-raised-button class="artstuff-orange artstuff-dialog-button mat-subheading-2" (click)="dialogRef.close(true)">
                {{ 'DEFAULT_DIALOG.ACCEPT_BTN_TEXT' | translate }}
            </button>
        </ng-template>
    </span>

    <!-- In case there is no Accept button, margin left by 148px -->
    <span [ngClass]="{'ml-148': data.hideAcceptBtn === true}">
        <button *ngIf="data.cancelBtnText; else templateNameCancelBtn" mat-button class="artstuff-dialog-button mat-subheading-2 grey-600-fg" (click)="dialogRef.close(false)">
            {{ data.cancelBtnText }}
        </button>
        <ng-template #templateNameCancelBtn>
            <button mat-button class="artstuff-dialog-button mat-subheading-2 grey-600-fg" (click)="dialogRef.close(false)">
                {{ 'DEFAULT_DIALOG.CANCEL_BTN_TEXT' | translate }}
            </button>
        </ng-template>
    </span>
</div>
